




















































import { Vue, Component, Watch } from "vue-property-decorator";
import { UserService, SkcServerOrderService } from "src/services";
import { IAppModel, IMenuModel, IUserLoginInfoModel } from "src/model";
import { ServerOrderStatusType } from "src/enums";
import router from '../../router';
import { EnumUtils } from "src/utils";

@Component
export default class payFail extends Vue
{
     /**
     * 订单状态
     * @protected
     */
    protected orderState : any =
    {
        isPayed: false,
        message: "",
        status: 0
    }
      /**
     * 获取订单状态名称
     * @protected
     */
    protected getOrderStateName(value: number):string
    {
        return EnumUtils.getEntry(value,ServerOrderStatusType)?.alias || "";
    }
    /**
     * 获取平台服务
     * @private
     * @return SkcServerOrderService
     */
    private _skcServerOrderService: SkcServerOrderService;

     /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get skcServerOrderService(): SkcServerOrderService
    {
        if(!this._skcServerOrderService)
        {
            this._skcServerOrderService = this.$serviceProvier.resolve<SkcServerOrderService>(SkcServerOrderService);
        }

        return this._skcServerOrderService;
    }

    /**
     * 获取用户服务
     * @private
     * @return UserService
     */
    private _userService: UserService;

    /**
     * 弹框显示
     * @protected
     * @returns 
     */
    protected visible: boolean = false;

    /**
     * 获取或设置用户服务。
     * @protected
     * @returns UserService
     */
    protected get userService(): UserService
    {
        if(!this._userService)
        {
            this._userService = this.$serviceProvier.resolve<UserService>(UserService);
        }

        return this._userService;
    }

    /**
     * 用户信息
     * @protected
     * @type {any}
     */
    protected get userInfo(): any {

        return this.$store.getters["global/userInfo"]
    }

    /**
     * 获取用户信息
     * @private
     * @return Promise<void>
     */
    private async getLoginInfo(): Promise<void>
    {
        try
        {
            let {content: result} = await this.userService.getLoginInfo();
            if(result.data)
            {
                // 存储登入所有信息
                this.$store.dispatch("user/setProfile", result.data);
            }
        } 
        catch(err)
        {
            
            this.$message.error({
                duration: 3,
                content: JSON.stringify(err)
            })
        }
    }


    /**
     * 组件创建钩子。
     * @protected
     * @returns void
     */
    protected created(): void
    {
        if (this.$route.query.id)
        {
            let id = parseInt((this.$route.query as any).id);
            this.getPayResult(id);
        }
    }
 /**
     *  获取订单结果
     * @protected
     * @returns void
     */
    protected async getPayResult(id: number): Promise<void>
    {
        
         try
        {
            let {content: result} = await this.skcServerOrderService.getPayResult(id);
            if (result && result.data)
            {
                this.orderState = result.data;
            }
        } 
        catch(err)
        {
            this.$message.error({
                duration: 3,
                content: JSON.stringify(err)
            })
        }
    }
    /**
   * 注销登录
   * @protected
   * @return void
   */
  protected async logout(): Promise<void> {
    try {
      await this.userService.logout();
    } catch (err) {
      this.$message.error({
        duration: 3,
        content: err || "服务器错误",
      });
    }
  }

    /**
     * 退出登录
     * @protected
     * @returns void
     */
    protected loginOut(): void
    {
        this.$confirm({
            title: "提示",
            content: "是否确定注销登录 ?",
            okText: "确定",
            cancelText: "取消",
            onOk: async () => {
                return await this.logout()
                .then(() => {
                    setTimeout(() => {
                        localStorage.clear();
                        this.$router.push("/")
                    }, 20);
                })
                .catch(() => {
                    this.$message.error("注销失败");
                });
            },
            onCancel() {},
        });
    }
      /**
   * 跳转订单页
   * @protected
   * @return void
   */
  protected readOrder(): void {
    this.$router.push({name:'versionOrder', query:{id: this.$route.query.id}})
  }

   /**
     * 返回首页
     * @protected
     * @returns void
     */
    protected gotoIndex(): void
    {
       this.$router.push({name: 'shop'})
    }
    
}
